import type { TreeMapSubFilterCardProps } from "./tree-map-sub-filter-card.type";

import { Collapse } from "antd";
import { useTranslation } from "react-i18next";

import TreeMapSubFilterResetButton from "../tree-map-sub-filter-reset-button";

import "./tree-map-sub-filter-card.style.less";

const TreeMapSubFilterCard = ({
  type,
  closed,
  children,
}: TreeMapSubFilterCardProps) => {
  const { t } = useTranslation();

  const label = t(`global:treeMap.subFilter.${type}`);

  const extra = (
    <TreeMapSubFilterResetButton
      type={type}
      onClick={(e) => e.stopPropagation()}
    />
  );

  const childrenNode = children ? (
    <div className="tree-map-sub-filter-card-content">{children}</div>
  ) : null;

  return (
    <Collapse
      defaultActiveKey={closed ? undefined : type}
      items={[{ key: type, label, extra, children: childrenNode }]}
      className="tree-map-sub-filter-card"
      size="small"
      ghost
      classNames={{
        header: "tree-map-sub-filter-card--header",
        title: "tree-map-sub-filter-card--title",
        body: "tree-map-sub-filter-card--body",
        icon: "tree-map-sub-filter-card--expand-icon",
      }}
    />
  );
};

export default TreeMapSubFilterCard;
